import { render } from "./IconBadge.vue.ts?vue&type=template&id=cd309aa1&ts=true!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./IconBadge.vue?vue&type=template&id=cd309aa1&ts=true"
import script from "./IconBadge.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./IconBadge.vue?vue&type=script&lang=ts&setup=true"
export * from "./IconBadge.vue.ts?vue&type=script&lang=ts&setup=true!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./IconBadge.vue?vue&type=script&lang=ts&setup=true"

import "./IconBadge.vue.css?vue&type=style&index=0&id=cd309aa1&lang=css!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./IconBadge.vue?vue&type=style&index=0&id=cd309aa1&lang=css"

import exportComponent from "../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/shared-components/ui/IconBadge.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cd309aa1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cd309aa1', __exports__)) {
    api.reload('cd309aa1', __exports__)
  }
  
  module.hot.accept("./IconBadge.vue.ts?vue&type=template&id=cd309aa1&ts=true!=!../../../node_modules/rspack-vue-loader/dist/index.js??ruleSet[0].use[0]!./IconBadge.vue?vue&type=template&id=cd309aa1&ts=true", () => {
    api.rerender('cd309aa1', render)
  })

}


export default __exports__